export function redirectToExternalUrl(url: string): void {
  window.location.assign(url);
}
